module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-135.83221219.svg";